// extracted by mini-css-extract-plugin
export default {"melodyVideo":"zR-z","isFullWidth":"AR-z","landingPageVideo":"BR-z","play":"CR-z","iframeVideo":"DR-z","playHidden":"ER-z","fullwidth":"FR-z"};